module.exports = __webpack_public_path__ + "static/media/bg-pattern.d35958ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-pattern.png
// module id = 1048
// module chunks = 0